export const ROLE_NAMES = {
	VEX: 'VEX',
	VEX_SUPPORT: 'VEX Support',
	SYSTEM_ADMINISTRATOR: 'System Administrator',
	SERVICE_PROVIDER: 'Service Provider',
	VKO: 'VKO',
	VKO_EXTERNAL: 'VKO External',
	APPROVER: 'Approver',
	READER: 'Reader',
	BEDARFSKOORDINATOR: 'Bedarfskoordinator',
	REGULATION_READER: 'Regulation Reader',
	AVK: 'AnlagenVorschriftenKoordinator',
	BAV: 'Bereichsexperte Anlagenvorschriften',
} as const;
